import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { globalConst } from 'src/app/shared/helpers/constants';
import { AuthService } from './shared/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = globalConst.systemTitle;

  @Input() isLoggedIn = false;

  constructor(
    private router: Router,
    private authService: AuthService,
  ) { }

  ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

    this.isLoggedIn = (this.authService.isLoggedIn());
    this.authService.loggedInEmitter.subscribe(
      isLoggedIn => this.isLoggedIn = isLoggedIn
    );
  }

  onActivate(event) {
    window.scroll(0, 0);
  }
}

